module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mb-12 pb-8",
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": _vm.$vuetify.breakpoint.xsOnly
    }
  }, _vm._l((_vm.submodule), function(submodul) {
    return _c('v-col', {
      key: submodul.id,
      staticClass: "pa-1",
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "4",
        "lg": "4",
        "xl": "3"
      }
    }, [(submodul.value === 'chargen') ? _c('chargen', {
      attrs: {
        "vorstand": submodul.props[0].wert,
        "showTitle": true
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'geburtstage') ? _c('geburtstage') : _vm._e(), _vm._v(" "), (submodul.value === 'jubilaum') ? _c('jubilaum', {
      attrs: {
        "semester": submodul.props[0].wert
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'kontakteStatus') ? _c('kontakteStatus', {
      attrs: {
        "status": submodul.props[0].wert
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'mailsListe') ? _c('mailsListe', {
      attrs: {
        "bbr": _vm.currentBbr
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'rechnungenEigene') ? _c('rechnungenEigene', {
      attrs: {
        "bbr": _vm.currentBbr
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'rechnungenStatus') ? _c('rechnungenStatus', {
      attrs: {
        "kasse": submodul.props[0].wert,
        "status": submodul.props[1].wert
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'ripuaren') ? _c('ripuaren') : _vm._e(), _vm._v(" "), (submodul.value === 'todosEigene') ? _c('todosEigene') : _vm._e(), _vm._v(" "), (submodul.value === 'veranstaltungenListe') ? _c('veranstaltungenListe', {
      attrs: {
        "anzahl": "5"
      }
    }) : _vm._e(), _vm._v(" "), (submodul.value === 'bundesbruderSuche') ? _c('bundesbruderSuche') : _vm._e(), _vm._v(" "), (submodul.value === 'bierranking') ? _c('bierranking') : _vm._e(), _vm._v(" "), (submodul.value === 'schankverlust') ? _c('schankverlust') : _vm._e(), _vm._v(" "), (submodul.value === 'rechnungSuche') ? _c('rechnungSuche') : _vm._e(), _vm._v(" "), (submodul.value === 'keilkandidaten') ? _c('keilkandidaten') : _vm._e()], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83ee6818"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/uebersicht.vue
// module id = 797
// module chunks = 15